module.exports = __webpack_public_path__ + "static/media/new-bb-banner.e1930faf.png";